module.exports = "/_next/static/images/img-empty-45908702.png";